import { type PopupProps, Popup } from '@CS/components/Popups';
import { useNavigateQuery } from '@/hooks';
import { useTranslation } from '@CS/hooks';
import Button from '@CS/components/Button';
import CSS from './Win.module.css';
import Content from './content';

export const Win = (props: PopupProps) => {
  const navigate = useNavigateQuery();
  const onClick = () => navigate('/form');
  const { title, description, enter } = useTranslation(Content);

  return (
    <Popup
      hideClose
      {...props}
      opacity="0"
      className={CSS.winContainer}
    >
      <div className={CSS.winContent}>
        <h4>{title}</h4>
        <span>{description}</span>
        <Button text={enter} onClick={onClick} />
      </div>
    </Popup>
  );
};
